import { useTranslation } from "react-i18next";

export const usePastTimeDifference = (date: Date) => {
  const { t } = useTranslation();

  const past = Math.floor(date.getTime() / 1000 / 60 / 60 / 24);
  const today = Math.floor(Date.now() / 1000 / 60 / 60 / 24);

  const diff = today - past;

  if (diff < 1) {
    return t("today");
  }

  if (diff < 2) {
    return t("yesterday");
  }

  return t("{{days}} days ago", { days: diff });
};

export const useFutureTimeDifference = (date: Date) => {
  const { t, i18n } = useTranslation();

  const future = Math.floor(date.getTime() / 1000 / 60 / 60 / 24);
  const today = Math.floor(Date.now() / 1000 / 60 / 60 / 24);

  const diff = future - today;

  let text: string;
  if (diff < 1) {
    text = t("today at {{time}}", {
      time: date.toLocaleTimeString(i18n.language, {
        timeZoneName: "short",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }),
    });
  } else if (diff < 2) {
    text = t("tomorrow");
  } else {
    text = t("in {{days}} days", { days: diff });
  }

  return { text, days: diff };
};
